"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsService = exports.ProductsServiceError = void 0;
class ProductsServiceError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ProductsServiceError';
        Object.setPrototypeOf(this, ProductsServiceError.prototype);
    }
}
exports.ProductsServiceError = ProductsServiceError;
class ProductsService {
    constructor(tdcClient) {
        this.tdcClient = tdcClient;
    }
    getProductsBySkus(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.tdcClient.post('/product/', JSON.stringify(params), {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    signal: options === null || options === void 0 ? void 0 : options.signal,
                });
                return response.data;
            }
            catch (error) {
                throw new ProductsServiceError('Error fetching products by skus');
            }
        });
    }
}
exports.ProductsService = ProductsService;
